import React, { useState } from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Box } from "@mui/material";
import { Dayjs } from "dayjs";

interface DateRangePickerProps {
  onDateChange: (range: { startDate: Dayjs | null; endDate: Dayjs | null }) => void;
  initialValue?: { startDate: Dayjs | null; endDate: Dayjs | null };
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({ onDateChange, initialValue }) => {
  const [startDate, setStartDate] = useState<Dayjs | null>(initialValue?.startDate ?? null);
  const [endDate, setEndDate] = useState<Dayjs | null>(initialValue?.endDate ?? null);

  const emitChange = (newStart: Dayjs | null, newEnd: Dayjs | null) => {
    onDateChange({ startDate: newStart, endDate: newEnd });
  };

  const handleStartDateChange = (newDate: Dayjs | null) => {
    setStartDate(newDate);
    if (newDate && endDate && endDate.isBefore(newDate)) {
      setEndDate(null);
      emitChange(newDate, null);
    } else {
      emitChange(newDate, endDate);
    }
  };

  const handleEndDateChange = (newDate: Dayjs | null) => {
    setEndDate(newDate);
    emitChange(startDate, newDate);
  };

  return (
      <Box display="flex" gap={2}>
        <DatePicker
          label="Fecha Desde"
          value={startDate}
          onChange={handleStartDateChange}
          format="DD-MM-YYYY"
          slotProps={{ textField: { fullWidth: true } }}
        />
        <DatePicker
          label="Fecha Hasta"
          value={endDate}
          onChange={handleEndDateChange}
          minDate={startDate??undefined} // Ensures end date is after start date
          format="DD-MM-YYYY"
          slotProps={{ textField: { fullWidth: true } }}
        />
      </Box>
  );
};

export default DateRangePicker;
